<template>
  <div class="content">
    <div class="top">
      <ul class="third">
        <li class="nav-item" style="display: inline-block; width: 100px;" v-for="(item, index) in navListHelp"
          :key="index" @click="skip(index, item.title, 'help')">
          {{ item.title }}
        </li>
      </ul>

    </div>
    <div class="text">
      <span> &nbsp;&nbsp;&nbsp;&nbsp;河北旭诚智联供应链有限公司 </span>
      <span> &nbsp;&nbsp;&nbsp;&nbsp;地址：中国(河北)自由贸易试验区正定片区园博园大街19号河北出版传媒创意中心2016-15 </span>
      <br>
      <span>版权声明&nbsp;&nbsp;&nbsp;&nbsp; </span>
      <span><el-link href="https://beian.miit.gov.cn/" target="_blank" style="text-decoration: underline; ">
          冀ICP备2024061089号-1 </el-link></span>
      <span><el-link href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13012302000619" target="_blank"
          style="text-decoration: underline; padding-left: 20px;">
          <img src="http://www.gzzczb.com/m/test/static/images/gwab.png" style="float: left;padding-right: 5px;">
          冀公网安备13012302000619号 </el-link>
      </span>
    </div>
  </div>
</template>

<script>

export default {
  components: {

  },
  data() {
    return {
      navListHelp: [{ title: '联系我们' }, { title: 'CA相关' }, { title: '投标指南' }, { title: '专家指南' },],
      navListAbout: [{ title: '联系我们' }],
    }
  },
  methods: {
    skip(activeName, item, type) {
      if (item === '联系我们' || item === '联系我们') {
        this.$router.push({
          path: "/ourself",
          query: { activeName: activeName },
        });
        this.$bus.$emit("changeMainNav", "/ourself");
      } else {
        this.$router.push({
          path: "/help",
          query: { activeName: activeName },
        });
        this.$bus.$emit("changeMainNav", "/help");
      }
      // if (type=='help') {
      //   this.$router.push({
      //     path: "/help",
      //     query: {activeName: activeName },
      //   });
      //   this.$bus.$emit("changeMainNav", "/help");
      // } else if(type=='about'){
      //   this.$router.push({
      //     path: "/ourself",
      //     query: {activeName: activeName },
      //   });
      //   this.$bus.$emit("changeMainNav", "/ourself");
      // }


    },
  }
}
</script>
<style scoped lang="less">
.nav-item {
  cursor: pointer;
}

.nav-item:hover {
  color: #409EFF; // Element 蓝色
}

.content {
  //background-color: #fff;
  width: 100%;
  height: 82px;
  // margin-top: 25px;
  padding: 10px 0;
  color: #FFFFFF;
}

a {
  text-decoration: none;
  color: white;
}

.content .top ul {
  text-align: left;
  font-size: 14px;
}

.top {
  width: 1000px;
  margin: 0 auto;
  display: flex;
  justify-content: space-evenly;
}

.top ul li {
  color: #fff;
  margin-bottom: 15px;
  //&:nth-of-type(1){
  //  font-size: 16px;
  //  color:#FFFFFF;
  //}
}

.top .first {
  margin-left: 100px;

}

hr {
  background: -webkit-linear-gradient(left, #ffffff, #ffffff, #ffffff, #ffffff, #ffffff);
  /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(right, #ffffff, #ffffff, #ffffff, #ffffff, #ffffff);
  /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(right, #ffffff, #ffffff, #ffffff, #ffffff, #ffffff);
  /* Firefox 3.6 - 15 */
  background: linear-gradient(to right, #ffffff, #ffffff, #ffffff, #ffffff, #ffffff);
  /* 标准的语法 */
  border: none;
  height: 1px;
  opacity: 1;
}

.text {
  text-align: center;
  font-size: 14px;
  color: #ffffff;
  //padding-top: 10px;
}

.text a {
  color: #ffffff;
}

hr {
  //margin-top: 5px;
}
</style>
